import clsx from "clsx";
import PropTypes from "prop-types";
import "./round-loading-spinner.css";

function RoundLoadingSpinner({ className }) {
  return <div className={clsx("round-loader", className)}></div>;
}

RoundLoadingSpinner.propTypes = {
  className: PropTypes.string,
};

export default RoundLoadingSpinner;
